import jsIcon from '../assets/icons/js.png'; 
import expressjsIcon from '../assets/icons/expressjs.png'; 
import mssqlIcon from '../assets/icons/mssql.png'; 
import muiIcon from '../assets/icons/mui.png'; 
import mysqlIcon from '../assets/icons/mysql.png'; 
import nodejsIcon from '../assets/icons/nodejs.png'; 
import postgresqlIcon from '../assets/icons/postgresql.png'; 
import reactjsIcon from '../assets/icons/reactjs.png'; 
import reduxIcon from '../assets/icons/redux.webp'; 
import restapiIcon from '../assets/icons/restapi.jpg'; 
import tsIcon from '../assets/icons/ts.png'; 
import awsIcon from '../assets/icons/aws.png'; 
import gitIcon from '../assets/icons/git.png'; 
import rtlIcon from '../assets/icons/rtl.png';
import jestIcon from '../assets/icons/jest.png';
import githubIcon from '../assets/icons/github.png'
import vsCodeIcon from '../assets/icons/vscode.png'
import jiraIcon from '../assets/icons/jira.png'

export type ExpertiseLevel = 'expert' | 'proficient' | 'familiar';

export interface Skill {
  name: string;
  image: string;
  years: number;
  expertise: ExpertiseLevel; 
}

export const FRONTEND_SKILLS = [
    {
        name: "JavaScript",
        image: jsIcon,
        years: 7,
        expertise: "expert"
    },
    {
        name: "TypeScript",
        image: tsIcon,
        years: 3,
        expertise: "proficient"
    },
    {
        name: "React",
        image: reactjsIcon,
        years: 6,
        expertise: "expert"
    },
{
        name: "React Testing Library",
        image: rtlIcon,
        years: 4,
        expertise: "proficient"
    },
    {
        name: "Redux",
        image: reduxIcon,
        years: 4,
        expertise: "proficient"
    },
    {
        name: "Material UI",
        image: muiIcon,
        years: 5,
        expertise: "proficient"
    },
]

export const BACKEND_SKILLS = [
    {
        name: "Node.js",
        image: nodejsIcon,
        years: 7,
        expertise: "expert"
    },
    {
        name: "Express.js",
        image: expressjsIcon,
        years: 7,
        expertise: "expert"
    },
        {
        name: "REST",
        image: restapiIcon,
        years: 7,
        expertise: "expert"
    },     
       
    {
        name: "Jest",
        image: jestIcon,
        years: 2,
        expertise: "familiar"
    },
        {
        name: "PostgreSQL",
        image: postgresqlIcon,
        years: 2,
        expertise: "proficient"
    },
    {
        name: "MySQL",
        image: mysqlIcon,
        years: 3,
        expertise: "proficient"
    },
    {
        name: "MSSQL",
        image: mssqlIcon,
        years: 2,
        expertise: "proficient"
    },

]

export const OTHER_SKILLS = [

    {
        name: "AWS",
        image: awsIcon,
        years: 2
    },
    {
        name: "Git",
        image: gitIcon,
        years: 7
    },
    {
        name: "Github",
        image: githubIcon,
        years: 7
    },

    {
        name: "Visual Studio Code",
        image: vsCodeIcon,
        years: 7
    },
    {
        name: "Jira",
        image: jiraIcon,
        years: 2
    },
]